var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"U_title"},[_c('div',{staticClass:"U_title_content"},[_vm._v("Your Location："+_vm._s(this.Target.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }